import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

import AppLayout from '@/components/layout/AppLayout';

export default function SalespersonRoute() {
  const { isSalesperson, isSuperUser, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // SU usa /dashboard como página de entrada minimal (sólo saludo). Sin esta
  // excepción el guard lo redirige a /admin (ManagerDashboard) por compartir
  // isSalesManager con SalesManager.
  if (!isSalesperson && !isSuperUser) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
